import { render, staticRenderFns } from "./AccOwnRequests.vue?vue&type=template&id=6a39c507&scoped=true&"
import script from "./AccOwnRequests.vue?vue&type=script&lang=js&"
export * from "./AccOwnRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a39c507",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3001884671/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a39c507')) {
      api.createRecord('6a39c507', component.options)
    } else {
      api.reload('6a39c507', component.options)
    }
    module.hot.accept("./AccOwnRequests.vue?vue&type=template&id=6a39c507&scoped=true&", function () {
      api.rerender('6a39c507', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/Devices/Accessories/AccOwnRequests.vue"
export default component.exports